import { DELEGATEBYADMIN_FETCHED, CURRENT_DELEGATE } from "../types";

const initialState = {
  delegateByAdminData: [] as any,
  delegateByAdmin:[] as any
};

const delegationByAdmin = (state = initialState, action: any) => {
  switch (action.type) {
    case DELEGATEBYADMIN_FETCHED:
      return {
        ...state,
        delegateByAdminData: action.delegateByAdminData,
      };
    case CURRENT_DELEGATE:
      return {
        ...state,
        delegateByAdmin: action.delegateByAdmin,
      };
    default:
      return state;
  }
};

export default delegationByAdmin;



